<div class="flex flex-col md:flex-row md:items-end" [ngClass]="{ 'my-base': hasFilters }">
  <div class="flex-1 flex flex-wrap gap-sm">
    @for (filter of filters; track filter) {
      @if (filter.text) {
        <div
          class="flex items-center px-base py-xs rounded-full border border-txt-secondary text-base leading-base text-txt-secondary"
        >
          <mg-table-filter
            [filter]="tableActions.filters?.[filter.key] ?? { key: filter.key }"
            [sort]="tableActions.sort"
            (filterChanged)="onFilterChanged(filter.key, $event)"
          >
            <span>
              {{ filter.text }}
            </span>
          </mg-table-filter>

          <div class="flex ml-sm cursor-pointer" (click)="removeItem(filter.key)">
            <svg-icon key="close" class="!text-xs"></svg-icon>
          </div>
        </div>
      }
    }
  </div>

  @if (showExport) {
    <mg-button
      class="block self-end mt-base md:mt-0"
      icon="export"
      variant="ghost"
      [loading]="exportLoading"
      extraBtnClass="!py-0"
      (click)="exportClicked.emit()"
    >
      Export to CSV
    </mg-button>
  }
</div>
